import { topics } from '@/mocks/home';

export default function TopicsSection() {
  return (
    <section id="topics" className="py-10 md:py-14 bg-background-50">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 mb-6">
          <i className="ri-hashtag text-primary-500 mr-2"></i>
          热门话题
        </h2>
        <div className="flex flex-wrap gap-2 md:gap-3">
          {topics.map((topic) => (
            <span
              key={topic.label}
              className={`inline-flex items-center gap-1.5 px-4 py-2 rounded-full text-sm font-medium cursor-pointer transition-all duration-200 whitespace-nowrap ${
                topic.active
                  ? 'bg-primary-500 text-background-50'
                  : 'bg-background-100 text-foreground-700 hover:bg-background-200 border border-background-200/70'
              }`}
            >
              <i className={`${topic.icon} text-base`}></i>
              {topic.label}
              <span className={`text-xs ml-1 ${topic.active ? 'text-background-50/70' : 'text-secondary-400'}`}>
                {topic.heat}
              </span>
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}